import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ld_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const path = window.location.pathname;
    const isPublic = path.startsWith("/sign") || path.startsWith("/invite") || path.startsWith("/forgot");
    if (err?.response?.status === 401 && !isPublic) {
      localStorage.removeItem("ld_token");
      localStorage.removeItem("ld_user");
      if (path !== "/signin") window.location.href = "/signin";
    }
    return Promise.reject(err);
  }
);

export default api;
